import Vue from 'vue';

Vue.component('access-token-list', () =>
    import(/* webpackChunkName: 'access-token-list' */ './access-token-list.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/access-token/index.js